import React from 'react';

export default function StatisticsDesktopSectionHeader({
  badge,
  iconSrc,
  title,
}) {
  return (
    <div className="flex items-center justify-between gap-3 mb-3 shrink-0">
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-8 h-8 rounded-lg bg-gray-50 border border-gray-100 flex items-center justify-center">
          <img src={iconSrc} alt="" className="w-4 h-4 object-contain" />
        </div>
        <h3 className="font-bold text-[15px] text-gray-800 truncate">{title}</h3>
      </div>
      {badge && (
        <span className="text-[10px] font-bold px-2 py-0.5 rounded-md bg-gray-50 border border-gray-100 text-gray-500">
          {badge}
        </span>
      )}
    </div>
  );
}
